import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Plus } from 'lucide-react';
import { REALMS } from '../data/realms';
import { Filigree } from './Ornaments';
import { Reveal } from './Reveal';

export const RealmPortals = () => (
  <section id="realms" className="relative bg-[#EDE7DF] pt-16 md:pt-20" data-testid="realm-portals-section">
    <div className="plaque relative bg-[#06111F]">
      <div className="plaque-tab">
        <h2 className="portal-title text-center" data-testid="realm-portals-title">
          Four Realms. Countless Encounters. One Witness.
        </h2>
      </div>
      <Filigree className="!inset-3 md:!inset-5" />

      <Reveal className="relative max-w-6xl mx-auto px-5 sm:px-8 md:px-12 pt-12 md:pt-16 pb-12 md:pb-16">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10 md:gap-x-8">
          {REALMS.map((realm, i) => (
            <Reveal key={realm.slug} delay={i * 120}>
              <Link to={`/realm/${realm.slug}`} className="realm-portal group flex flex-col items-center text-center" data-testid={`realm-portal-${realm.slug}`}>
                <img src={realm.sigil} alt={`${realm.name} sigil`} className="portal-sigil" draggable="false" />
                <p className="portal-numeral mt-1">Realm {realm.numeral}</p>
                <h3 className="portal-name mt-2">{realm.name}</h3>
                <p className="portal-sub mt-2">{realm.subtitle}</p>
                <span className="portal-plus mt-5" aria-hidden><Plus className="w-3.5 h-3.5" strokeWidth={1.25} /></span>
              </Link>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 md:mt-14 flex items-center justify-center gap-4 md:gap-6">
          <span className="portal-flourish hidden sm:block" aria-hidden />
          <Link to="/realm/the-deep" className="portal-enter" data-testid="enter-journey-btn">
            Enter the Journey <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.5} />
          </Link>
          <span className="portal-flourish portal-flourish--r hidden sm:block" aria-hidden />
        </div>
      </Reveal>
    </div>
    <div className="h-16 md:h-24 bg-gradient-to-b from-[#06111F] to-[#080A0D]" aria-hidden />
  </section>
);
